import { Button, IconButton, Stack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BiLogOut } from 'react-icons/bi';
import { FiPower } from 'react-icons/fi';
import { SidebarItemType } from "../../routes/Links";

export function SidebarButton({
  name,
  Icon,
  link,
  selected,
}: SidebarItemType) {
  return (
    <Button
      boxShadow={"base"}
      border={"1px"}
      borderColor={"#e9e9e9"}
      rounded={"md"}
      bg={"white"}
      transition={'width 1s'}
      bgGradient={selected ? "linear(to-r, primary.100, primary.600)" : "none"}
      _hover={{
        bg: "white",
        boxShadow: "lg",
        bgGradient: selected
          ? "linear(to-r, primary.100, primary.200)"
          : "none",
        color: selected ? "white" : "textColor.supportingText",
      }}
      _active={{
        bgGradient: "linear(to-r, primary.100, primary.600)",
        color: "white",
        boxShadow: "xl",
        outline: "none",
      }}
      _focus={{ outline: "none" }}
      color={selected ? "white" : "textColor.supportingText"}
      leftIcon={<Icon />}
      size={"lg"}
      fontSize={'md'}
      as={Link}
      to={link}
      justifyContent={'flex-start'}
      fontWeight={500}
      w={'full'}
    >
      {name}
    </Button>
  );
}
export function SidebarButtonMobile({
  name,
  Icon,
  link,
  selected,
}: SidebarItemType) {
  return (
    <IconButton
      aria-label={name}
      boxShadow={"base"}
      border={"1px"}
      borderColor={"#e9e9e9"}
      rounded={"md"}
      bg={"white"}
      bgGradient={selected ? "linear(to-r, primary.100, primary.600)" : "none"}
      _hover={{
        bg: "white",
        boxShadow: "lg",
        bgGradient: selected
          ? "linear(to-r, primary.100, primary.200)"
          : "none",
        color: selected ? "white" : "textColor.supportingText",
      }}
      _active={{
        bgGradient: "linear(to-r, primary.100, primary.600)",
        color: "white",
        boxShadow: "xl",
        outline: "none",
      }}
      _focus={{ outline: "none" }}
      color={selected ? "white" : "textColor.supportingText"}
      icon={<Icon />}
      size={"lg"}
      fontSize={"sm"}
      as={Link}
      to={link}
      w={"20px"}
    />
  );
}

export function SidebarBottomButtons() {
  return (
    <Stack>
      <Button
        // color={'textColor.supportingText'}
        _focus={{ outline: "none" }}
        leftIcon={<FiPower />}
        size={"lg"}
        fontWeight={500}
        variant={'ghost'}
        color={'red.400'}
        justifyContent={'start'}
      >
        Disconnect
      </Button>
      <Button
        // color={'textColor.supportingText'}
        _focus={{ outline: "none" }}
        leftIcon={<BiLogOut color="red.400" />}
        size={"lg"}
        fontWeight={500}
        variant={'ghost'}
        color={'red.400'}
        justifyContent={'start'}
      >
        Logout
      </Button>
    </Stack>
  )
}

export function SidebarBottomIconButtons() {
  return (
    <Stack>
      <IconButton
        aria-label={"Disconnect"}
        boxShadow={"base"}
        border={"1px"}
        borderColor={"#e9e9e9"}
        rounded={"md"}
        bg={"white"}
        bgGradient={"linear(to-r, red.400, red.500, red.500, red.600)"}
        _hover={{
          bg: "white",
          boxShadow: "lg",
          bgGradient: "linear(to-r, red.500, red.600, red.600, red.700)",
          color: "white",
        }}
        _active={{
          bgGradient: "linear(to-r, red.600, red.700, red.800, red.900)",
          color: "white",
          boxShadow: "xl",
          outline: "none",
        }}
        _focus={{ outline: "none" }}
        color={"white"}
        icon={<FiPower />}
        size={"lg"}
        fontSize={"sm"}
        w={{ base: "2xl", md: "20px" }}
      />
      <IconButton
        aria-label={"Disconnect"}
        boxShadow={"base"}
        border={"1px"}
        borderColor={"#e9e9e9"}
        rounded={"md"}
        bg={"white"}
        bgGradient={"linear(to-r, red.400, red.500, red.500, red.600)"}
        _hover={{
          bg: "white",
          boxShadow: "lg",
          bgGradient: "linear(to-r, red.500, red.600, red.600, red.700)",
          color: "white",
        }}
        _active={{
          bgGradient: "linear(to-r, red.600, red.700, red.800, red.900)",
          color: "white",
          boxShadow: "xl",
          outline: "none",
        }}
        _focus={{ outline: "none" }}
        color={"white"}
        icon={<BiLogOut />}
        size={"lg"}
        fontSize={"sm"}
        w={{ base: "2xl", md: "20px" }}
      />
    </Stack>
  )
}